import React from 'react'

export default ({ ...props }) => (
  <svg {...props} width='28' height='20' viewBox='0 0 28 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.7071 2.70711C15.0976 2.31658 15.0976 1.68342 14.7071 1.29289C14.3166 0.902369 13.6834 0.902369 13.2929 1.29289L14.7071 2.70711ZM6 10L5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L6 10ZM13.2929 18.7071C13.6834 19.0976 14.3166 19.0976 14.7071 18.7071C15.0976 18.3166 15.0976 17.6834 14.7071 17.2929L13.2929 18.7071ZM13.2929 1.29289L5.29289 9.29289L6.70711 10.7071L14.7071 2.70711L13.2929 1.29289ZM5.29289 10.7071L13.2929 18.7071L14.7071 17.2929L6.70711 9.29289L5.29289 10.7071Z'
      fill='#0D0D0D'
    />
    <path
      d='M22.7071 2.70711C23.0976 2.31658 23.0976 1.68342 22.7071 1.29289C22.3166 0.902369 21.6834 0.902369 21.2929 1.29289L22.7071 2.70711ZM14 10L13.2929 9.29289C12.9024 9.68342 12.9024 10.3166 13.2929 10.7071L14 10ZM21.2929 18.7071C21.6834 19.0976 22.3166 19.0976 22.7071 18.7071C23.0976 18.3166 23.0976 17.6834 22.7071 17.2929L21.2929 18.7071ZM21.2929 1.29289L13.2929 9.29289L14.7071 10.7071L22.7071 2.70711L21.2929 1.29289ZM13.2929 10.7071L21.2929 18.7071L22.7071 17.2929L14.7071 9.29289L13.2929 10.7071Z'
      fill='#0D0D0D'
    />
  </svg>
)
